import { createSelector } from 'reselect';
import { redux } from 'Core/redux';
import { STORE_KEY, INITIAL_STATE } from './slice';

export const selectState = state => {
  const appState = state || redux.store.getState();
  return appState?.[STORE_KEY] || INITIAL_STATE;
};

export const selectDashboardData = state => selectState(state).dashboardData || INITIAL_STATE.dashboardData;
export const selectDashboardLoading = state => selectState(state).loading;
export const selectDashboardError = state => selectState(state).error;

// Memoized selectors to prevent unnecessary rerenders
export const selectDashboardTiles = createSelector(
  [selectDashboardData],
  (dashboardData) => ({
    tile1: dashboardData.tile1 || 0,
    tile2: dashboardData.tile2 || 0,
    tile3: dashboardData.tile3 || 0,
    tile4: dashboardData.tile4 || 0,
    tile5: dashboardData.tile5 || 0,
    tile6: dashboardData.tile6 || 0,
    tile7: dashboardData.tile7 || 0,
    tile8: dashboardData.tile8 || 0
  })
);

export const selectProcessDetails = createSelector(
  [selectDashboardData],
  (dashboardData) => dashboardData.processDetails || []
); 